import { render } from "./AppNavAlert.vue?vue&type=template&id=c8b50444&ts=true"
import script from "./AppNavAlert.vue?vue&type=script&lang=ts"
export * from "./AppNavAlert.vue?vue&type=script&lang=ts"

import "./AppNavAlert.vue?vue&type=style&index=0&id=c8b50444&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__